export const STORAGE_KEYS = {
  BROWSER_TAB: 'BROWSER_TAB',
  STORED_TABS: 'STORED_TABS',
};

export const setTabsInLocalStorage = (tabReducer, userEmail) => {
  if (!userEmail) {
    return;
  }

  localStorage.setItem(
    `${userEmail}_${STORAGE_KEYS.STORED_TABS}`,
    JSON.stringify(tabReducer)
  );
};

export const getTabsFromLocalStorage = userEmail => {
  const tabReducer = localStorage.getItem(
    `${userEmail}_${STORAGE_KEYS.STORED_TABS}`
  );
  if (!tabReducer) {
    return null;
  }
  return JSON.parse(tabReducer);
};
